import { ErrorPage } from '@launcher/components/ErrorPage';
import { AppError } from '@launcher/constants';
import { EnvManager } from '@services/environment/environment.service';
import { logger } from '@services/logger/logger.service';

export const EnvProvider = ({ children }: { children: React.ReactNode }) => {
  if (!EnvManager.isReady()) {
    logger.error('LOGIC', 'missing required env variable');
    return <ErrorPage errorKey={AppError.InvalidEnvVariables} />;
  }

  return <>{children}</>;
};
